const { debounce } = window.BAO.Utils

class ProductAlterations extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (!this.els?.input?.element || !this.els?.submit?.element) return

    this.els.submit.element.disabled = true

    this.debouncedClamp = debounce(() => {
      this.clampToBoundsAndStep()
      this.toggleSubmitState()
    }, 1000)

    this.els.input.element.addEventListener('input', () => {
      this.debouncedClamp()
      this.toggleSubmitState()
    })

    this.els.submit.element.addEventListener('click', () => {
      this.handleConfirm()
    })

    this.externalEls.remove.element.addEventListener('click', () => {
      this.resetAlterations()
    })
  }

  clampToBoundsAndStep () {
    const rawValue = (this.els.input.element.value ?? '').trim()
    if (rawValue === '') return

    let value = Number(rawValue)
    if (Number.isNaN(value)) return

    const minValue = Number(this.els.input.element.getAttribute('min'))
    const maxValue = Number(this.els.input.element.getAttribute('max'))
    const step = Number(this.els.input.element.getAttribute('step')) || 1

    if (value < minValue) value = minValue
    if (value > maxValue) value = maxValue

    const offset = value - minValue
    value = minValue + Math.round(offset / step) * step

    if (value < minValue) value = minValue
    if (value > maxValue) value = maxValue

    const decimals = step.toString().includes('.')
      ? step.toString().split('.')[1].length
      : 0
    value = Number(value.toFixed(decimals))

    this.els.input.element.value = String(value)
  }

  toggleSubmitState () {
    if (!this.els.submit.element) return
    const value = this.els.input.element.value.trim()
    this.els.submit.element.disabled =
      value === '' || Number.isNaN(Number(value))
  }

  handleConfirm () {
    if (!this.externalEls.form.element) return

    const currentValue = this.els.input.element.value.trim()
    if (currentValue === '' || Number.isNaN(Number(currentValue))) return

    const fieldName = 'properties[Chain Stitch Service]'
    let hiddenInput = this.externalEls.form.element.querySelector(
      `input[name="${fieldName}"]`,
    )

    if (!hiddenInput) {
      hiddenInput = document.createElement('input')
      hiddenInput.type = 'hidden'
      hiddenInput.name = fieldName
      this.externalEls.form.element.appendChild(hiddenInput)
    }

    hiddenInput.value = currentValue

    this.updateAlterationsText(currentValue)

    this.externalEls.default.element.setAttribute('aria-hidden', true)
    this.externalEls.added.element.setAttribute('aria-hidden', false)
  }

  updateAlterationsText (value) {
    if (!this.externalEls.text.element) return

    if (value && value !== '') {
      const addedText = this.externalEls.text.element.dataset.addedText || ''
      this.externalEls.text.element.textContent =
        `${value}" ${addedText}`.trim()
    }
  }

  resetAlterations () {
    this.removeHiddenInput()

    this.els.input.element.value = ''
    this.externalEls.default.element.setAttribute('aria-hidden', false)
    this.externalEls.added.element.setAttribute('aria-hidden', true)
  }

  removeHiddenInput () {
    if (!this.externalEls.form.element) return
    const hiddenInput = this.externalEls.form.element.querySelector(
      `input[name="properties[Chain Stitch Service]"]`,
    )
    if (hiddenInput) hiddenInput.remove()
  }
}

if (!customElements.get('product-alterations')) {
  customElements.define('product-alterations', ProductAlterations)
}
